import {
  Card,
  CardBody,
  CardHeader,
  Heading,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";

export default function AvailableSoon() {
  return (
    <>
      <Card>
        <CardHeader>
          <Heading size="md">Presto disponibile</Heading>
        </CardHeader>
        <CardBody>
          <Text>Torna presto per vedere gli aggiornamenti!</Text>
        </CardBody>
      </Card>
    </>
  );
}
